import { createFileRoute, Outlet } from '@tanstack/react-router';
import { PERMISSION_REFUELING_CARDS } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';
import FuelCards from '../../components/FuelCards';

export const Route = createFileRoute('/_authenticated/fuel_cards')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_REFUELING_CARDS, ['read'], '/unauthorized', context);

    return {
      ...context,
      documentTitle: {
        main: 'menu.fuelCardsOverview',
        suffix: 'menu.refuelings',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: FuelCardsRoute,
});

function FuelCardsRoute() {
  return (
    <>
      {/* Always render the list */}
      <FuelCards />
      {/* Outlet will render child routes (detail modal, etc.) on top */}
      <Outlet />
    </>
  );
}
